import { api } from 'app/config/apiConfig';
import { SendContractClosureNotificationParams } from '../model/types';

export const sendContractClosureNotificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendContractClosureNotification: builder.mutation<void, SendContractClosureNotificationParams>({
      query: (data) => ({
        url: `contracts/${data.contractId}/closure-notification`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useSendContractClosureNotificationMutation } = sendContractClosureNotificationApi;
